class ProductConfirmation {
  constructor(root) {
    this.root = root;
    this.checkbox = root.querySelector('input[type="checkbox"]');
    this.controls = root.nextElementSibling;
    this.form = this.controls?.querySelector('form[action*="/cart/add"]');
    this.button = this.controls?.querySelector('.product-form__submit');
    this.fieldset = this.controls?.querySelector('[data-confirmation-fieldset]');

    if (!this.checkbox || !this.controls || !this.form || !this.button || !this.fieldset) return;
    this.form.addEventListener('submit', (event) => {
      if (!this.checkbox.checked) event.preventDefault();
    });
    this.checkbox.addEventListener('change', () => this.update());
    this.update();
  }

  update() {
    const confirmed = this.checkbox.checked;
    this.controls.toggleAttribute('data-confirmation-pending', !confirmed);
    this.fieldset.disabled = !confirmed;
    if (confirmed) this.button.removeAttribute('aria-disabled');
    else this.button.setAttribute('aria-disabled', 'true');
  }
}

const initializedConfirmations = new WeakSet();
const initializeConfirmations = (scope = document) => {
  scope.querySelectorAll('[data-colour-confirmation]').forEach((root) => {
    if (initializedConfirmations.has(root)) return;
    initializedConfirmations.add(root);
    new ProductConfirmation(root);
  });
};

initializeConfirmations();
new MutationObserver((records) => {
  records.forEach((record) => record.addedNodes.forEach((node) => {
    if (node.nodeType === Node.ELEMENT_NODE) initializeConfirmations(node);
  }));
}).observe(document.documentElement, { childList: true, subtree: true });
